import Marionette from "marionette";
import template from "apps/RunnedApps/view/template/RunnedAppItemView.html";


let RunnedAppItemView = Marionette.ItemView.extend("RunnedAppItemView", {
    template,
    className: "RunnedAppItemView",
    ui: {
        $close: ".RunnedAppItemView--close"
    },
    events: {
        click: "onClick",
        "click @ui.$close": "onClickClose"
    },

    onClick(e) {
        e.preventDefault();

        if ( e.target == this.ui.$close[0] ) {
            return;
        }

        this.triggerMethod("show");
    },

    onClickClose(e) {
        e.preventDefault();
        this.triggerMethod("close");
    }
});

export default RunnedAppItemView;
